


<template>
    <!-- 耕雲導師年谱初稿 -->
    <div class="firstDraft">
        <topBack>{{$t('lastNews')}}</topBack>
        <barF5></barF5>
        <div class="flex-center">
            <table border="1" cellspacing="0" class="tableStyle">
                <tr>
                    <th class="tableVirMidd f85 W4">{{$t('lastDate')}}</th>
                    <th class="tableVirMidd f85 tl">{{$t('articleTitle1')}}</th>
                    <th class="tableVirMidd f85 tl W4">{{$t('articleCategory')}}</th>
                </tr>
                <tr v-for="(item,index) in content" :key="index" @click.prevent="linkToDetail(item)">
                    <td class="tableVirMidd f80">{{item.data}}</td>
                    <td class="tableVirMidd tl">{{item.news_title}}</td>
                    <td class="tableVirMidd tl td_content" @click.stop="toclass(item)">{{item.cate_name}}</td>
                </tr>
            </table>
        </div>
         <!-- 底部button -->
        <!-- <footer>
            <Button>{{$t('firstHome')}}</Button>
        </footer> -->
    </div>
</template>

<script>
import { getTimeBeforeDay } from "../common/js/common";
import { getMoreStudy } from "../api/apis";
import barF5 from "../components/barF5";
import topBack from "../components/topBack";
import Button from '../components/button'
export default {
    name: "",
    components: {
        barF5,
        topBack,
        Button
    },
    data() {
        return {
            content: [
                // {
                //     id: 31,
                //     belong_cate_id: 16,
                //     news_title: "持诵金刚经得定要诀",
                //     data: "2020-02-06 15:54:15",
                //     cate_name: "书信往来"
                // },
                // {
                //     id: 30,
                //     belong_cate_id: 16,
                //     news_title: "六祖大师法宝坛经",
                //     data: "2020-02-06 15:53:45",
                //     cate_name: "书信往来"
                // }
            ]
        };
    },
    methods: {
        toclass(item){
            console.log(item)
            if(item.cate_name == '修学心得'){
                this.$router.push({
                    path:"/friendWen",
                    query:{
                        id:0
                    }
                })
            }
            if(item.cate_name == '书信往来'){
                this.$router.push({
                    path:"/friendWen",
                    query:{
                        id:1
                    }
                })
            }
        },
        linkToDetail(item) {
            this.$router.push({
                path: "/articleDetail",
                query: { name: "experience", id: item.id,title:this.$t('lastNews') }
            }); //跳转到心得详情
        }
    },
    mounted() {
        getMoreStudy().then(res => {
            // this.content = getTimeBeforeDay(res, "data");
            this.content = res;
        });
        //重新设置表格颜色
    }
};
</script>

<style scoped>
.firstDraft {
    color: #333333;
    /* font-size: 0.59rem !important; */
    font-size: 0.85rem ;
}

.tableStyle {
    width: 100%;
    text-align: center;
    margin: 0.64rem;
}

.tableVirMidd {
    display: table-cell;
    vertical-align: middle;
    line-height: 1rem;
}

table {
    border: 1px solid #999999 !important;
}

th {
    border: 1px solid #999999;

    height: 3rem;
}

td {
    border: solid #999999;
    border-width: 1px 1px 1px 1px;
    /* height: 2rem; */
}
.td_content {
    padding: 0.5rem;
    text-align: left;
}
.f85 {
    font-size: 0.85rem;
}
.f80{
    font-size: 0.80rem;
}
.W2 {
    width: 2.5rem;
}
.W4 {
    width: 4.5rem;
}
.tl {
    text-align: left;
    padding-left: 0.5rem;
}
</style>